export const BORDER_WIDTHS = {
  0: 0,
  none: 0,
  thin: "0.5px",
  base: "1px",
  thick: "2px",
};
